import api from './api';
import { Grn } from '../types/grn';

export async function listGrns(jobCardId: number): Promise<Grn[]> {
  const res = await api.get(`/jobcards/${jobCardId}/grns`);
  return res.data?.data || [];
}

export async function createGrn(jobCardId: number, payload: Partial<Grn>): Promise<Grn> {
  const res = await api.post(`/jobcards/${jobCardId}/grns`, payload);
  return res.data?.data;
}

export async function getGrn(grnId: number): Promise<Grn> {
  const res = await api.get(`/grns/${grnId}`);
  return res.data?.data;
}

export async function updateGrn(grnId: number, payload: Partial<Grn>): Promise<Grn> {
  const res = await api.put(`/grns/${grnId}`, payload);
  return res.data?.data;
}

export async function finalizeGrn(grnId: number): Promise<Grn> {
  const res = await api.post(`/grns/${grnId}/finalize`);
  return res.data?.data;
}

export async function deleteGrn(grnId: number): Promise<void> {
  await api.delete(`/grns/${grnId}`);
}

export async function getPoItems(jobCardId: number): Promise<any[]> {
  const res = await api.get(`/jobcards/${jobCardId}/po-items`);
  return res.data?.data || [];
}


